module.exports = __webpack_public_path__ + "cb6cea3af6898538ce6d7ea88eecde90.jpg";